import { CURRENCIES, formatMinor, type CurrencyCode } from '@trestly/shared';

/**
 * «1 242.84»: узкий неразрывный пробел между тысячами читается быстрее
 * сплошных цифр. Знак минуса — типографский «−», а не дефис.
 */
export function money(minor: number, currency: CurrencyCode): string {
  const raw = formatMinor(Math.abs(minor), currency);
  const [whole = '', frac] = raw.split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${minor < 0 ? '−' : ''}${grouped}${frac !== undefined ? `.${frac}` : ''}`;
}

/**
 * Официальный знак белорусского рубля (НБРБ). В Юникоде его пока нет: шрифт
 * НБРБ кладёт его на U+E901 из области частного использования, подключён в
 * styles.css только для этого символа.
 */
export const BYN_SIGN = '\uE901';

/** Знак валюты для показа рядом с суммой: $ или знак рубля. */
export function currencySign(currency: CurrencyCode): string {
  return currency === 'USD' ? CURRENCIES.USD.symbol : BYN_SIGN;
}

/**
 * С валютой: USD — знаком перед суммой ($42.00), BYN — знаком НБРБ после
 * суммы через неразрывный пробел, как принято писать рубли.
 */
export function moneyLabel(minor: number, currency: CurrencyCode): string {
  return currency === 'USD'
    ? `${CURRENCIES.USD.symbol}${money(minor, currency)}`
    : `${money(minor, currency)}\u00a0${BYN_SIGN}`;
}
